import * as React from 'react';

const SvgArrowBigUp = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "m13 7.14 6 5.04V9.56l-7-5.87-7 5.87v2.62l6-5.04V20h2V7.14Z" })
);

export { SvgArrowBigUp as default };
//# sourceMappingURL=ArrowBigUp.es.js.map
